'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports['default'] = OnlinepbxTable;

var _onlinepbxTableSelect = require('./onlinepbx-table-select');

var _onlinepbxTableSelect2 = _interopRequireDefault(_onlinepbxTableSelect);

var _onlinepbxTableInput = require('./onlinepbx-table-input');

var _onlinepbxTableInput2 = _interopRequireDefault(_onlinepbxTableInput);

var _onlinepbxTableInputTimeLogic = require('./onlinepbx-table-input-time-logic');

var _onlinepbxTableInputTimeLogic2 = _interopRequireDefault(_onlinepbxTableInputTimeLogic);

var _onlinepbxTableMultiselect = require('./onlinepbx-table-multiselect');

var _onlinepbxTableMultiselect2 = _interopRequireDefault(_onlinepbxTableMultiselect);

var _onlinepbxTableUploadFile = require('./onlinepbx-table-upload-file');

var _onlinepbxTableUploadFile2 = _interopRequireDefault(_onlinepbxTableUploadFile);

var _onlinepbxTableTextarea = require('./onlinepbx-table-textarea');

var _onlinepbxTableTextarea2 = _interopRequireDefault(_onlinepbxTableTextarea);

var _onlinepbxCheckbox = require('../onlinepbx-checkbox');

var _onlinepbxCheckbox2 = _interopRequireDefault(_onlinepbxCheckbox);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _onlinepbxQuestion = require('../onlinepbx-question');

var _onlinepbxQuestion2 = _interopRequireDefault(_onlinepbxQuestion);

var _onlinepbxSwitch = require('../onlinepbx-switch');

var _onlinepbxSwitch2 = _interopRequireDefault(_onlinepbxSwitch);

var _reactPerfectScrollbar = require('react-perfect-scrollbar');

var _reactPerfectScrollbar2 = _interopRequireDefault(_reactPerfectScrollbar);

var _currentCalendar = require('../onlinepbx-calendar/current-calendar');

var _currentCalendar2 = _interopRequireDefault(_currentCalendar);

var _onlinepbxTableCalendar = require('./onlinepbx-table-calendar');

var _onlinepbxTableCalendar2 = _interopRequireDefault(_onlinepbxTableCalendar);

var _onlinepbxDotCheckbox = require('../onlinepbx-dot-checkbox');

var _onlinepbxDotCheckbox2 = _interopRequireDefault(_onlinepbxDotCheckbox);

var _onlinepbxRadio = require('../onlinepbx-radio');

var _onlinepbxRadio2 = _interopRequireDefault(_onlinepbxRadio);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MIN_CLIENT_HEIGHT = 100;

function OnlinepbxTable(_ref) {
  var emptyText = _ref.emptyText,
      onYReachEnd = _ref.onYReachEnd,
      onClickLine = _ref.onClickLine,
      className = _ref.className,
      rows = _ref.rows,
      classNameHead = _ref.classNameHead,
      isHead = _ref.isHead,
      headCols = _ref.headCols,
      classNamesCols = _ref.classNamesCols,
      array = _ref.array,
      optimize = _ref.optimize,
      rowHeight = _ref.rowHeight,
      classNameScrollbar = _ref.classNameScrollbar,
      childrenAfterRows = _ref.childrenAfterRows,
      optionsScroll = _ref.optionsScroll,
      propsScrollbar = _ref.propsScrollbar;

  var countRows = rows && rows.length || 0;

  return _react2['default'].createElement(
    'div',
    { className: 'onlinepbx__lib__table' },
    countRows > 0 && isHead && _react2['default'].createElement(
      'div',
      { className: (0, _classnames2['default'])('onlinepbx__lib__table__head', classNameHead) },
      headCols.map(function (col, index) {
        return _react2['default'].createElement(
          'div',
          {
            key: index.toString(),
            className: (0, _classnames2['default'])('onlinepbx__lib__table__head__text', col.className) },
          col.text,
          col.question && _react2['default'].createElement(_onlinepbxQuestion2['default'], {
            text: col.question
          })
        );
      })
    ),
    countRows === 0 && emptyText && _react2['default'].createElement(
      'div',
      { className: 'onlinepbx__lib__table__empty' },
      emptyText
    ),
    _react2['default'].createElement(RenderRows, {
      onYReachEnd: onYReachEnd,
      classNameScrollbar: classNameScrollbar,
      rows: rows,
      classNamesCols: classNamesCols,
      array: array,
      countRows: countRows,
      optimize: optimize,
      rowHeight: rowHeight,
      childrenAfterRows: childrenAfterRows,
      optionsScroll: optionsScroll,
      propsScrollbar: propsScrollbar
    })
  );
}

var RenderRows = function (_React$Component) {
  _inherits(RenderRows, _React$Component);

  function RenderRows() {
    _classCallCheck(this, RenderRows);

    var _this = _possibleConstructorReturn(this, (RenderRows.__proto__ || Object.getPrototypeOf(RenderRows)).call(this));

    _this.state = {
      top: 0,
      clientHeight: document.body.clientHeight
    };
    return _this;
  }

  _createClass(RenderRows, [{
    key: 'render',
    value: function () {
      function render() {
        var _this2 = this;

        var _props = this.props,
            onYReachEnd = _props.onYReachEnd,
            classNameScrollbar = _props.classNameScrollbar,
            rows = _props.rows,
            classNamesCols = _props.classNamesCols,
            array = _props.array,
            countRows = _props.countRows,
            optimize = _props.optimize,
            _props$rowHeight = _props.rowHeight,
            rowHeight = _props$rowHeight === undefined ? 40 : _props$rowHeight,
            childrenAfterRows = _props.childrenAfterRows,
            optionsScroll = _props.optionsScroll,
            propsScrollbar = _props.propsScrollbar;
        var _state = this.state,
            clientHeight = _state.clientHeight,
            top = _state.top;


        if (clientHeight <= MIN_CLIENT_HEIGHT) {
          setTimeout(function () {
            return _this2.setState({ clientHeight: document.body.clientHeight });
          }, 200);
        }

        var skipRows = 0;
        var showRows = countRows;
        var afterRowsCount = 0;

        if (optimize) {
          var height = Math.ceil(clientHeight * 1.8);
          var skipHeight = Math.max(0, Math.floor(top - Math.ceil(clientHeight * 0.4)));

          showRows = Math.min(countRows, Math.ceil(height / rowHeight));
          if (showRows !== countRows) {
            skipRows = Math.floor(skipHeight / rowHeight);
            afterRowsCount = Math.max(0, countRows - skipRows - showRows);
          }
        }

        return _react2['default'].createElement(
          _reactPerfectScrollbar2['default'],
          _extends({}, propsScrollbar, {
            options: optionsScroll,
            onYReachEnd: onYReachEnd,
            onScrollY: function () {
              function onScrollY(container) {
                return _this2.setState({ top: container.scrollTop });
              }

              return onScrollY;
            }(),
            className: (0, _classnames2['default'])('scrollbar__dark', classNameScrollbar) }),
          rows && skipRows && _react2['default'].createElement('div', { key: 'onlinepbx__lib__table_rows_before', style: { height: skipRows * rowHeight } }) || '',
          rows && rows.slice(skipRows, skipRows + showRows).map(function (row, number) {
            return _react2['default'].createElement(
              _react2['default'].Fragment,
              null,
              _react2['default'].createElement(
                'div',
                {
                  key: row.key || number.toString(),
                  onClick: function () {
                    function onClick() {
                      typeof row.onClickLine === 'function' && row.onClickLine(row.id);
                    }

                    return onClick;
                  }(),
                  className: (0, _classnames2['default'])('onlinepbx__lib__table__line', row.classnameLine, {
                    'onlinepbx__lib__table__line__hover': row.isHover
                  }) },
                row.cols.map(function (col, index) {
                  return _react2['default'].createElement(
                    'div',
                    {
                      key: col.key || number.toString() + index.toString() + col.type.toString(),
                      className: (0, _classnames2['default'])('onlinepbx__lib__table__line__text', classNamesCols && classNamesCols[index]) },
                    detectField(col),
                    col.question && _react2['default'].createElement(_onlinepbxQuestion2['default'], {
                      title: col.questionTitle,
                      text: col.question
                    })
                  );
                })
              ),
              row.isOpenedSubRow && row.subRow
            );
          }) || array,
          rows && afterRowsCount && _react2['default'].createElement('div', { key: 'onlinepbx__lib__table_rows_after', style: { height: afterRowsCount * rowHeight } }) || '',
          childrenAfterRows
        );
      }

      return render;
    }()
  }]);

  return RenderRows;
}(_react2['default'].Component);

function detectField(col) {
  var type = col.type,
      key = col.key,
      props = _objectWithoutProperties(col, ['type', 'key']);

  switch (type) {
    case 'select':
      return _react2['default'].createElement(_onlinepbxTableSelect2['default'], props);
    case 'input':
      return _react2['default'].createElement(_onlinepbxTableInput2['default'], _extends({
        isControlValue: true
      }, props));
    case 'input-time':
      return _react2['default'].createElement(_onlinepbxTableInputTimeLogic2['default'], _extends({
        isControlValue: true
      }, props));
    case 'switch':
      return _react2['default'].createElement(
        'div',
        { className: 'onlinepbx__lib__table__switch' },
        _react2['default'].createElement(_onlinepbxSwitch2['default'], props)
      );
    case 'calendar':
      return _react2['default'].createElement(_currentCalendar2['default'], props);
    case 'calendar-period':
      return _react2['default'].createElement(_onlinepbxTableCalendar2['default'], props);
    case 'multiselect':
      return _react2['default'].createElement(_onlinepbxTableMultiselect2['default'], props);
    case 'textarea':
      return _react2['default'].createElement(_onlinepbxTableTextarea2['default'], props);
    case 'checkbox':
      return _react2['default'].createElement(_onlinepbxCheckbox2['default'], props);
    case 'radio':
      return _react2['default'].createElement(_onlinepbxRadio2['default'], props);
    case 'upload':
      return _react2['default'].createElement(_onlinepbxTableUploadFile2['default'], props);
    case 'dot-checkbox':
      return _react2['default'].createElement(_onlinepbxDotCheckbox2['default'], props);
    case 'div':
      return _react2['default'].createElement(
        'div',
        {
          title: (typeof col.value === 'string' || typeof col.value === 'number') && col.value || '',
          className: (0, _classnames2['default'])('onlinepbx__lib__table__div', {
            'onlinepbx__lib__table__div__disabled': col.disabled
          }) },
        col.value
      );
    case 'value-div':
      return _react2['default'].createElement(
        'div',
        {
          title: col.title || (typeof col.value === 'string' || typeof col.value === 'number') && col.value || '',
          className: (0, _classnames2['default'])('onlinepbx__lib__table__div__value', {
            'onlinepbx__lib__table__div__value__disabled': col.disabled
          }) },
        col.value
      );
    case 'label':
      return _react2['default'].createElement(
        'div',
        {
          title: typeof col.value === 'string' && col.value || '',
          className: 'onlinepbx__lib__table__label' },
        col.value
      );
    default:
      return _react2['default'].createElement(
        'div',
        {
          title: typeof col.value === 'string' && col.value || '',
          className: 'onlinepbx__lib__table__div' },
        col.value
      );
  }
}